<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Administrator bearbeiten') }}</h1>
        </div>

        <form @submit.prevent="form.put(route('admin.admins.update', admin))">
            <form-fields
                :form="form"
                :admin="admin" 
                />
        </form>

        <hr />

        <div class="d-flex justify-content-between">
            <div class="mb-4">
                <inertia-link :href="route('admin.users.create', {account_id: admin.id})" class="btn btn-outline-primary">
                    {{ __('Benutzer erstellen') }}
                </inertia-link>
            </div>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'admin',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: this.admin.name,
                    phone: this.admin.phone,
                    fax: this.admin.fax,
                    email: this.admin.email,
                    notes: this.admin.notes,
                }),
                columns: {
                    id: {label: 'ID'},
                    name: {label: 'Name'},
                    email: {label: 'Email'},
                    notes: {label: 'Notes'},
                },
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>